import cookie from '@commonJS/cookie'
import ls from '@commonJS/localStorage'
import reduceCookie from '@commonJS/reduceCookie'

const sign = {
    state: {
        messagesShow: false,
        messagesValue: {
            value: '',
            type: 3,
            time: 2000
        }
    },
    mutations: {
        SET_SHOW_TRUE(state, obj) {
            state.messagesShow = true
            state.messagesValue = {
                value: obj.value,
                type: obj.type,
                time: obj.time ? obj.time * 1 : 2000
            }
        },
        SET_SHOW_FALSE(state) {
            state.messagesShow = false
        }
    },
    actions: {}
}

export default sign


// WEBPACK FOOTER //
// ./src/base/vuex/modules/sign.js